import {
  BellAlertIcon,
  // FIX4: ClockIcon was the Business Hours tab icon — no longer used (tab removed).
  // ClockIcon,
  Cog6ToothIcon,
  UserGroupIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import CampaignBulkSection from "./CampaignBulkSection";
import CampaignSingleSection from "./CampaignSingleSection";
import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
// FIX4: the campaign-level Business Hours tab is removed. Campaign timing now follows the
// assistant's office hours (assistant Settings > Office Hours), surfaced via AssistantHoursNotice
// in BulkCampaignCreate.tsx, so a separate campaign schedule only confused users. Import kept
// commented for traceability (ported from SuperdashFrontend's identical FIX4 change).
// import BusinessHours from "./BusinessHours";
import FollowUps from "./FollowUps/FollowUps";

enum CampaignSection {
  SINGLE_CAMPAIGNS = "Single Campaigns",
  BULK_CAMPAIGNS = "Bulk Campaigns",
  // FIX4: Business Hours tab removed — timing comes from the assistant now.
  // BUSINESS_HOURS = "Business Hours",
  FOLLOW_UPS = "Follow Ups",
}

const CampaignSectionIcon = {
  [CampaignSection.BULK_CAMPAIGNS]: UserGroupIcon,
  [CampaignSection.SINGLE_CAMPAIGNS]: UserIcon,
  // FIX4: [CampaignSection.BUSINESS_HOURS]: ClockIcon,
  [CampaignSection.FOLLOW_UPS]: BellAlertIcon,
};

const CampaignSectionComponentsRegistry = {
  [CampaignSection.BULK_CAMPAIGNS]: (props) => (
    <CampaignBulkSection {...props} />
  ),
  [CampaignSection.SINGLE_CAMPAIGNS]: (props) => (
    <CampaignSingleSection {...props} />
  ),
  // FIX4: [CampaignSection.BUSINESS_HOURS]: (props) => <BusinessHours {...props} />,
  [CampaignSection.FOLLOW_UPS]: (props) => <FollowUps {...props} />,
};

export default function CampaignSections(props) {
  const { projectId, settings, fetchSettings, assistants, fetchAssistants, isViewOnly } =
    props;

  const [activeSection, setActiveSection] = useState<CampaignSection>(
    CampaignSection.SINGLE_CAMPAIGNS
  );

  useEffect(() => {
    if (projectId) {
      fetchAssistants(projectId);
    }
  }, [projectId]);

  const assistantsRecord = useMemo(() => {
    const record = assistants.reduce(
      (acc, assistant) => ({
        ...acc,
        [assistant._id]: assistant,
      }),
      {}
    );

    return record;
  }, [assistants]);

  return (
    <div className="flex h-full">
      <div className="flex flex-col items-center w-24 border-r overflow-scroll h-full">
        {Object.values(CampaignSection).map((section, idx) => {
          const Icon = CampaignSectionIcon[section];
          const isActiveSection = section === activeSection;
          return (
            <div
              className={clsx(
                `p-2 h-24 min-h-24 w-full flex flex-col gap-y-2 items-center justify-center cursor-pointer`,
                isActiveSection && "bg-zinc-950/80 text-gray-100",
                !isActiveSection &&
                  " hover:bg-gray-200 hover:outline outline-gray-300"
              )}
              onClick={() => setActiveSection(section)}
            >
              <Icon className="size-6" />
              <p className="text-xs wrap text-center">{section}</p>
            </div>
          );
        })}
      </div>
      <div className="w-full h-full flex-1 min-w-0 overflow-auto">
        {CampaignSectionComponentsRegistry[activeSection]({
          projectId,
          settings,
          fetchSettings,
          assistants,
          assistantsRecord,
          isViewOnly
        })}
      </div>
    </div>
  );
}
